var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"permissionTree"},[_c('el-tree',{ref:"tree",attrs:{"data":_vm.innerValue,"show-checkbox":"","node-key":"name","default-expand-all":true,"props":_vm.defaultProps},on:{"check":_vm.check,"check-change":_vm.checkChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }